import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type ContactFormState } from '../../../../contact-form'
import { type OpenableControls } from '../../../../generic-hooks'
import { useApiOrdersSwrGetOrders } from '../../../../order'
import { useDirectFormDialogContext } from '../DirectContactFormDialogContext'

import { DirectContactFormOrderProductItemsSelection } from './DirectContactFormOrderProductItemsSelection'
import { DirectContactFormOrderProductsSelection } from './DirectContactFormOrderProductsSelection'

export const DirectContactFormOrderSelectionDialogContent: FC<{
  formState: ContactFormState
  modalControls: OpenableControls
}> = ({ formState, modalControls }) => {
  const intl = useIntl()

  const { data } = useApiOrdersSwrGetOrders({
    itemsPerPage: 6,
    page: 0,
  })

  const { orderSelectionDialogTitle } = useDirectFormDialogContext()

  if (!data?.orders) {
    return null
  }

  const productType = new Set([
    intl.formatMessage({ id: 'direct.contact.form.order.cancellation' }),
    intl.formatMessage({ id: 'direct.contact.form.report.order' }),
    intl.formatMessage({ id: 'direct.contact.form.return.order' }),
  ])

  if (formState.model.subject && productType.has(formState.model.subject)) {
    return (
      <div
        className="flex h-full flex-col gap-2 p-4"
        data-qa-id="direct-contact-form-order-selection"
      >
        {orderSelectionDialogTitle ===
        intl.formatMessage({ id: 'direct.contact.form.select.order' }) ? (
          <DirectContactFormOrderProductsSelection
            formState={formState}
            modalControls={modalControls}
          />
        ) : (
          <DirectContactFormOrderProductItemsSelection
            modalControls={modalControls}
          />
        )}
      </div>
    )
  }

  return (
    <DirectContactFormOrderProductsSelection
      formState={formState}
      modalControls={modalControls}
    />
  )
}
